// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textComponents_heading__j5SAB {
  font-family: Inter;
  font-size: 2rem;
  font-weight: 700;
}

.textComponents_paragraph__8mUTc {
  font-family: Inter;
  font-size: 0.9rem;
  font-weight: 500;
}

/* @media screen {
  
} */`, "",{"version":3,"sources":["webpack://./src/Components/TextComponents/textComponents.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;GAEG","sourcesContent":[".heading {\n  font-family: Inter;\n  font-size: 2rem;\n  font-weight: 700;\n}\n\n.paragraph {\n  font-family: Inter;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n/* @media screen {\n  \n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heading": `textComponents_heading__j5SAB`,
	"paragraph": `textComponents_paragraph__8mUTc`
};
export default ___CSS_LOADER_EXPORT___;
